import { api } from '@/apis';
import { log } from '@/utils';
import { useDallasKeys } from '@/utils/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';

export function useRfidCard(id) {
  const queryKey = ['rfidCards', id];
  const queryClient = useQueryClient();
  const query = useQuery({
    queryKey,
    queryFn: async ({ signal }) => {
      if (id === 'new') {
        return {
          reference: '',
        };
      }

      const json = [
        {
          $match: {
            reference: id,
          },
        },
        {
          $project: {
            reference: true,
            category: true,
            type: true,
            label: true,
            time: true,
            lastEdit: true,
          },
        },
        {
          $lookup: {
            from: 'people',
            localField: 'reference',
            foreignField: 'rfidCards.reference',
            as: 'people',
          },
        },
        {
          $set: {
            people: {
              $filter: {
                input: '$people',
                as: 'person',
                cond: { $ne: ['$$person.deleted', true] },
              },
            },
          },
        },
      ];

      const cards = await api
        .post('pipeline/rfidCards', { json, signal })
        .json();

      log('Read', useDallasKeys ? 'Dallas Keys' : 'RFID Cards', { id });

      return cards[0] ?? null;
    },
    staleTime: 1000 * 60 * 60,
    enabled: !!id,
  });

  return {
    ...query,
    cancel: () => queryClient.cancelQueries({ queryKey }),
  };
}
